import { lazyLoad } from 'utils/loadable';

/**
 *
 * Asynchronously loads the component for Customer
 *
 */

const Customer = lazyLoad(
  () => import('app/modules/Customer'),
  (module) => module.default,
);

export default Customer;
